import styled, { createGlobalStyle } from "styled-components";
import { Skeleton } from "@material-ui/lab";
import { Button, IconButton } from "@material-ui/core";
import zIndex from "@material-ui/core/styles/zIndex";

export const DetailGlobalStyle = createGlobalStyle`
  html {
      height: 100%;

      body {
          height: 100%;
          overflow: hidden;

          #app {
              height: 100%;
          }
      }
  }
`;

export const DetailContainer = styled.aside`
  width: 100%;
  height: 100vh;
  display: flex;
  text-align: center;
  position: relative;
  touch-action: pan-x;
`;

export const Video = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: ${zIndex.drawer};

  object-fit: contain;
  background: transparent;
`;

export const VideoPlayButton = styled(IconButton)`
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  width: 60px;
  height: 60px;
`;

export const Mask = styled.section`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;

  background-image: linear-gradient(
    to top,
    rgba(31, 33, 38, 0.3),
    rgba(31, 33, 38, 0.07) 55%,
    rgba(31, 33, 38, 0) 70%,
    rgba(31, 33, 38, 0.3) 100%
  );
  background-size: 100%;
  background-position: 100% 50%;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${zIndex.drawer + 1};
`;

export const ActionContainer = styled.section`
  width: 100%;
  position: relative;
  margin-top: auto;
  padding: 18px 24px;

  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;
  z-index: ${zIndex.drawer + 2};
`;

export const InfoContainer = styled.div`
  text-align: left;
  width: calc(100% - 178px);

  .info-title {
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .info-title-ellipsis {
    padding-bottom: 5px;
    margin-bottom: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .info-description {
    display: block;
    line-height: 1.27;
    padding-bottom: 4px;
    margin-bottom: 4px;
    a {
      margin-right: 4px;
      font-weight: bold;
      word-break: unset;
      display: inline-block;
    }
    span:not(:last-child) {
      margin-right: 4px;
      display: inline;
      word-break: keep-all;
    }
  }
`;

export const DownloadButton = styled(Button)`
  position: absolute;
  bottom: 58px;
  right: 24px;
  font-weight: 500;
  &.reverse {
    right: auto;
    left: 24px;
  }
`;

export const MoreButton = styled.span`
  color: #d2d2d3;
`;

export const MoreInfoContainer = styled(InfoContainer)`
  width: 100%;
  height: 100%;
  white-space: pre-wrap;
  padding: 8px 24px;
  padding-top: 56px;
  overflow-y: auto;

  .info-description {
    span:not(:last-child) {
      margin-right: 4px;
      display: inline-block;
      word-break: keep-all;
    }
  }
`;

export const InfoSummaryContainer = styled.div`
  display: flex;
`;

export const InfoSummary = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  & + span {
    margin: 0 10px;
  }
  &.count {
    margin: 0 -10px;
  }
`;

export const InfoSummaryDividePoint = styled.span`
  width: 2px;
  height: 2px;
  background-color: #fff;
  border-radius: 50%;
  margin: 0 8px;
`;

export const FabContainer = styled.div`
  // top: 18px;
  // right: 24px;
  // transform: translateY(-100%);
  bottom: 120px;
  right: 18px;
  position: absolute;

  &.reverse {
    right: auto;
    left: 18px;
  }
`;

export const MuiIconButton = styled(IconButton)`
  padding: 8px;
  display: block;
  .MuiIconButton-label {
    display: block;
  }
`;

export const MuiSkeleton = styled(Skeleton)`
  background-color: rgba(255, 255, 255, 0.05);
`;
